module.exports = __webpack_public_path__ + "static/logo_full-418dd00b8667d4e2a1c670841a6b826f.png";